const MODULE = 'global_modules';
const SOCKET_HANDLER = 'socket_handler';
const CONNECT = 'connect';
const FETCH_CONFIGURATION = 'fetch_configuration';

/**
 * Joins all metric names, separated by a dot.
 * @param  {...string} names
 * @returns {string}
 */
const asGrafanaStat = (...names) => [
    MODULE,
    SOCKET_HANDLER,
    ...names
].join('.');

/**
 * Prefixes the event name with the create connection
 * event name.
 * @param {string} eventName
 * @returns {string}
 */
const connectEvent = (eventName) => asGrafanaStat(CONNECT, eventName);

/**
 * Prefixes the event name with the fetch configuration
 * event name.
 * @param {string} eventName
 * @returns {string}
 */
const fetchConfigurationEvent = (eventName) => asGrafanaStat(FETCH_CONFIGURATION, eventName);

export const METRICS = {
    CONNECT_SUCCESS: connectEvent('success'),
    CONNECT_FAILURE: connectEvent('failure'),
    CONNECT_SKIPPED: connectEvent('skipped'),
    FETCH_CONFIGURATION_SUCCESS: fetchConfigurationEvent('success'),
    FETCH_CONFIGURATION_FAILURE: fetchConfigurationEvent('failure')
};
